/* ==========================================================================
   PanelAccommodation > Client > AddRoom
   ========================================================================== */

/* Modules */
const ButtonClient = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/client/js');

const configuration = require('../config');

function initAddRoom(instance) {
    const result = instance;
    const { subscriptions = {} } = instance;

    result.addRoom = ButtonClient(`[data-component="ButtonRxjs"][data-type="${configuration().type.addBtn}"]`);

    if (result.addRoom) {
        /* Extend subscriptions */
        result.subscriptions = {
            ...subscriptions,
            addRoom: result.addRoom.events.click$.subscribe(event => {
                /* Prevent propagation for use inside uipanel */
                event.stopPropagation();

                /* Dispatch */
                instance.actions.addRoom();
            })
        };
    }
}

module.exports = {
    initAddRoom
};
